<div class="coupon-panel">
  <div class="coupon-panel-wrap">
    <i class="gift-icon"></i>
    <div class="content">
      <p class="title">{{ windowCouponAmount }} € {{ windowCouponLabel }}</p>
      <p>Jetzt passenden Kredit finden</p>
    </div>
    <a (click)="showCouponTip()">
      <i class="info"></i>
    </a>
  </div>
  <app-coupon-panel-tip
    [couponTipPopupStatus]="couponTipPopupStatus"
    (closePopup)="couponTipPopupStatus = false"
  ></app-coupon-panel-tip>
</div>
